import React from 'react'
import './App.css'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { useCookies } from 'react-cookie'
import Footer from './components/footer'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { ThemeProvider } from 'styled-components'
import 'react-datetime/css/react-datetime.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import qs from 'qs'
import {
    faFilePdf,
    faTimesCircle,
    faSearch,
    faCheckCircle,
    faCheckSquare,
    faCircle,
    faSquare,
    faBars,
    faArrowDown,
    faTimes,
    faSlidersH,
    faCaretUp,
    faCaretDown,
    faExchangeAlt,
    faMapMarkerAlt
} from '@fortawesome/free-solid-svg-icons'
import './i18n'
import SmbLandingPage from './pages/smb-landing-page'
import SmbInfo from './pages/smb-info'
import SmbProcess from './pages/smb-process'
import { CenteredToastContainer } from './components/CenteredToast'
import DocusignCallback from './pages/docusign_callback'
import { useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'
import "@fontsource/roboto-serif/400.css";
import "@fontsource/roboto-serif/700.css";
import "@fontsource/roboto-serif/500.css";
import "@fontsource/roboto-serif/600.css";

library.add(
    faFilePdf as any,
    faTimesCircle as any,
    faSearch as any,
    faCheckCircle as any,
    faCheckSquare as any,
    faCircle as any,
    faSquare as any,
    faBars as any,
    faArrowDown as any,
    faTimes as any,
    faSlidersH as any,
    faCaretUp as any,
    faCaretDown as any,
    faExchangeAlt as any,
    faMapMarkerAlt as any
)

const theme = {
    colors: {
        primary: '#38c3a8',
    },
}

const AppContent = () => {
    const location = useLocation();
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setWindowHeight(window.innerHeight);
        };
        
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const shouldShowFooter = !(
        (location.pathname === '/smb/process' || 
         location.pathname === '/smb/process/' || 
         location.pathname === '/smb/docusign_callback' || 
         location.pathname === '/smb/docusign_callback/') && 
        windowHeight < 900
    );

    return (
        <>
            <Routes>
                <Route path="/" element={<SmbLandingPage />} />
                <Route path="/smb" element={<SmbLandingPage />} />
                <Route path="/smb/info" element={<SmbInfo />} />
                <Route path="/smb/process" element={<SmbProcess />} />
                <Route path="/smb/process/" element={<SmbProcess />} />
                <Route path="/smb/docusign_callback" element={<DocusignCallback />} />
                <Route path="/smb/docusign_callback/" element={<DocusignCallback />} />
            </Routes>
            {/* {shouldShowFooter && <Footer />} */}
            <ToastContainer />
            <CenteredToastContainer />
        </>
    );
};

function App() {
    const { promo_code } = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    const [cookies, setCookie] = useCookies(['promo_code']);

    if (promo_code) {
        setCookie('promo_code', promo_code, { path: '/', maxAge: 1209600 });
    }

    return (
        <ThemeProvider theme={theme}>
            <BrowserRouter>
                <AppContent />
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App